import { YearSelect } from '../../../DateTime'
import { Control } from '../Control'

function ControlYear({ value, onChange, ...controlProps }) {
  function handleChange(nextValue) {
    onChange(value, { value: nextValue })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <YearSelect
        borderless
        disabled={value.omitted}
        value={value.value ?? null}
        onChange={handleChange}
      />
    </Control>
  )
}

export default ControlYear
